import React from 'react'
import { Text, TextName } from 'sdk/text/Text'
import { Avatar } from '../avatar/Avatar'

import styles from './style.module.scss'

interface TestimonialsAuthorProps {
  name: string;
  title: string;
  avatarSrc: string;
  avatarLink?: string;
  className?: string;
}

export const TestimonialsAuthor: React.FC<TestimonialsAuthorProps> = ({
  name,
  title,
  avatarSrc,
  avatarLink,
  className,
}) => {
  return (
    <div className={`${styles.author} ${className || ''}`}>
      <Avatar
        src={avatarSrc}
        alt={name}
        link={avatarLink}
        className={styles.avatar}
      />
      <div className={styles.authorInfo}>
        <Text type={TextName.TextBold} className={styles.name}>{name}</Text>
        <Text type={TextName.Text} className={styles.authorTitle}>{title}</Text>
      </div>
    </div>
  )
}
